export default "__VITE_ASSET__8KVhly2y__"